<app-dialog>
  <form (submit)="deleteTask()" data-testid="form">
    <label for="reason">Reason for deletion*</label>
    <input
      data-testid="input"
      required
      type="text"
      id="reason"
      class="form-control"
      name="reason"
      [(ngModel)]="reason"
    />
  </form>
</app-dialog>
<div class="dialog-actions">
  <app-new-action-button
    [text]="'Close'"
    (actionCompleted)="dialogRef.close()"
    [themedButton]="'primary'"
  ></app-new-action-button>
  <app-new-action-button
    [text]="'Delete Task' + (data.payload.isTaskSet ? ' Set' : '')"
    (actionCompleted)="deleteTask()"
    [themedButton]="'danger-secondary'"
    [isDisabled]="reason === ''"
  ></app-new-action-button>
</div>
